import { Offcanvas } from "react-bootstrap";
import "./Notifications.css";
import Common_Back_Btn from "../../../common/common_components/common_back_btn/Common_Back_Btn";
import { GetNotification } from "../../../features/admin/dashboard/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import React from "react";
function Notifications({ show, handleClose }) {
  const data = useSelector((state) => state.dashboard?.notifications);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = data?.total_pages;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      GetNotification({
        page: currentPage,
        per_page: 50||data.per_page,
      }),
    );
  }, [dispatch, currentPage]);

  const groupedNotifications = (data?.data || []).reduce((acc, curr) => {
    const date = new Date(curr.createdAt).toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    if (!acc[date]) acc[date] = [];
    acc[date].push(curr);
    return acc;
  }, {});

  // Now this is always safe
  const groupedArray = Object.entries(groupedNotifications);
  return (
    <>
      <Offcanvas
        className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
        show={show}
        placement="end"
        onHide={handleClose}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <div className="back_div" onClick={handleClose}>
              <Common_Back_Btn />
            </div>
            Notifications
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="Notifications_list_holder">
            {groupedArray.map(([date, items]) => (
              <div key={date}>
                {/* Date header */}
                <div className="date_holder_box">
                  <div className="date_holder">
                    <p>{date}</p>
                  </div>
                </div>

                {/* Notifications under that date */}
                {items.map((item) => (
                  <div
                    key={item.id}
                    className={`notification_card_hodler ${
                      item.status ? "active" : ""
                    }`}
                  >
                    <p>{item.message}</p>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Notifications;
